<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
/* 全局引入iconfont字体库 */
@import url('~/../assets/icon/iconfont.css');
@import url('~/../assets/icon_new/iconfont.css');
*{
  margin: 0;
  padding: 0;
}
html, body {
  margin: 0;
  padding: 0;
  width: 2048px;
  height: 1038px;
  min-width: 960px;
  transform-origin: 0 0 0;       /*指定缩放的基本点*/
  -moz-transform-origin: 0 0 0;
  -ms-transform-origin: 0 0 0;
  -webkit-transform-origin: 0 0 0;
  -o-transform-origin: 0 0 0;
  overflow: hidden;
}

#app{
  width: 100%;
  height: 100%;
  font-size: 14px !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue